import { logDebug } from '../utils/log';

interface ApiResponse {
    [key: string]: any;
}

class ApiClient {
    private baseUrl: string;
    private bearerToken: string;

    constructor(baseUrl: string, bearerToken: string) {
        this.baseUrl = baseUrl.replace(/\/$/, '');
        this.bearerToken = bearerToken;
    }

    private async request(endpoint: string, data: any): Promise<ApiResponse> {
        const url = this.baseUrl + endpoint;
        const headers = {
            'Authorization': `Bearer ${this.bearerToken}`,
            'Content-Type': 'application/json'
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            logDebug('Request failed:', error);
            throw error;
        }
    }

    public createModel(model: string, fields: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'create',
            model: model,
            fields: fields
        });
    }

    public saveData(model: string, data: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'save',
            model: model,
            data: data
        });
    }

    public updateData(model: string, index: any, data: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'update',
            model: model,
            index: index,
            data: data
        });
    }

    public getModel(model: string): Promise<ApiResponse> {
        return this.request('', {
            action: 'get',
            model: model
        });
    }

    public getPublicModel(model: string): Promise<ApiResponse> {
        return this.request('', {
            action: 'get_public',
            model: model
        });
    }

    public searchPublic(model: string, criteria: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'search_public',
            model: model,
            criteria: criteria
        });
    }

    public deleteInstance(model: string, index: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'delete_instance',
            model: model,
            index: index
        });
    }

    public deleteModel(model: string): Promise<ApiResponse> {
        return this.request('', {
            action: 'delete_model',
            model: model
        });
    }

    public search(model: string, criteria: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'search',
            model: model,
            criteria: criteria
        });
    }

    public getVersion(): Promise<ApiResponse> {
        return this.request('', {
            action: 'version'
        });
    }

    public login(model: string, criteria: any): Promise<ApiResponse> {
        return this.request('', {
            action: 'login',
            model: model,
            criteria: criteria
        });
    }

    public getStructure(model: string): Promise<ApiResponse> {
        return this.request('', {
            action: 'get_structure',
            model: model
        });
    }

    public getModels(): Promise<ApiResponse> {
        return this.request('', {
            action: 'get_models'
        });
    }
}

export default ApiClient;
